import React, { FunctionComponent } from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { moveSelectedItemsBack } from '../../actions/annotations';

type Props = ReturnType<typeof mapDispatchToProps>;

const SendBackward: FunctionComponent<Props> = ({ moveSelectedItemsBack }) => (
  <Tooltip disableInteractive disableFocusListener id="remove-page-tooltip" title="Send Backward">
    <div>
      <IconButton sx={{ borderRadius: 0 }} aria-label="Send Backward" onClick={moveSelectedItemsBack}>
        <KeyboardBackspaceIcon sx={{ transform: 'rotate(-90deg)' }} />
      </IconButton>
    </div>
  </Tooltip>
);

function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators({ moveSelectedItemsBack }, dispatch);
}

export default connect(null, mapDispatchToProps)(SendBackward);
